import { Base64 } from "js-base64"
import { Dictionary } from "@/core/collections/dictionary"

export class ClassUtil {
  public static getClassNames(
    model: any,
    seen: Set<any> = new Set(),
  ): string[] {
    const classNames: Set<string> = new Set()

    if (!model || typeof model !== "object" || seen.has(model)) return []
    seen.add(model)

    if (
      model.constructor &&
      model.constructor.name !== "Object" &&
      model.constructor.name !== "Array"
    ) {
      classNames.add(model.constructor.name)
    }

    for (const key of Object.keys(model)) {
      const value = model[key]

      if (Array.isArray(value)) {
        for (const item of value) {
          if (item && typeof item === "object") {
            for (const cn of ClassUtil.getClassNames(item, seen)) {
              classNames.add(cn)
            }
          }
        }
      } else if (value && typeof value === "object") {
        for (const cn of ClassUtil.getClassNames(value, seen)) {
          classNames.add(cn)
        }
      }
    }

    return Array.from(classNames)
  }

  public static getClassName<T>(model: T): string {
    if (model === null || model === undefined) {
      return ""
    }

    return (model as any)?.constructor?.name || ""
  }
}
